<template>
  <div>
    <el-container>
      <el-aside  width="325px">
        <el-page-header @back="goBack" style="margin-left: 20%;margin-top: 10%;"></el-page-header>
        <el-timeline style="margin-top: 15%;">
            <el-timeline-item timestamp="2018/4/12" placement="top"
             @click.native="haddle(hyCheck,1,1000)"
            >
              <el-card>
                <h4>{{hyCheck.name}}</h4>
                <el-progress :percentage="hyCheck.plan*100"></el-progress>
                  <el-tag
                  :type="hyCheck.state == 1?''
                  :(hyCheck.state==2?'success'
                  :(hyCheck.state==3?'info'
                  :(hyCheck.state==4?'danger':(hyCheck.state==5?'':'warning'))))"
                  effect="dark">
                    <div v-if="hyCheck.state == 1">进行中</div>
                    <div v-if="hyCheck.state == 2">待审核</div>
                    <div v-if="hyCheck.state == 3">已完成</div>
                    <div v-if="hyCheck.state == 4">已终止</div>
                    <div v-if="hyCheck.state == 5">已驳回</div>
                  </el-tag>

              </el-card>
            </el-timeline-item>

            <!-- <div  v-for="i in tableData" :key="i"> -->
            <el-timeline-item
             style="width: 250px;"
             placement="top"
             v-for="i in tableData" :key="i"
             :type="i.type"
             @click.native="haddle(i,index)"
             >
              <el-card>
                <h4>{{i.name}}</h4>
                <el-progress :percentage="i.plan*100"></el-progress>
                <h1 style="display: none;">{{i.id}}</h1>
                <el-tag
                :type="i.state == 1?''
                :(i.state==2?'info'
                :(i.state==3?'success'
                :(i.state==4?'danger':(i.state==5?'':'warning'))))"
                effect="dark">
                  <div v-if="i.state == 1">进行中</div>
                  <div v-if="i.state == 2">待审核</div>
                  <div v-if="i.state == 3">已完成</div>
                  <div v-if="i.state == 4">已终止</div>
                  <div v-if="i.state == 5">已驳回</div>
                </el-tag>
              </el-card>
            </el-timeline-item>
            <!-- </div> -->


          </el-timeline>
      </el-aside>


      <el-main style="background-color: white;">
          <CheckMissionDeatilTable ref="son"></CheckMissionDeatilTable>
      </el-main>
    </el-container>

  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import CheckMissionDeatilTable from "./CheckMissionDeatilTable.vue"
  export default {
     name: 'CheckMissionDeatil',
     components:{
       CheckMissionDeatilTable,
     },
     data () {
       return {
          checkId:'',
          taskId:123,
          hyCheck:{
            name:'',
            plan:'',
            state:'',
            type:'',
          },
          tableData:[{
           name:'',
           plan:'',
           state:'',
           id:'',
           type:'',
          }]
        };
     },
     mounted:function() {
       this.showVal();
     },
     methods: {
	   //返回上一级页面
       goBack(){
          this.$parent.page = 1
       },


	   //通过条件显示数据
       showVal(){
        var authorization = Cookies.get("Authorization");
        var paramsData = {
          checkId:this.$parent.checkId,
        }
        this.axios({
            method: 'GET',
            url: '/check/checkTab',
            params:paramsData,
            header:{
             'Authorization':authorization,
             'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{

            this.hyCheck = resp.data.data.hyCheck;
            this.tableData = resp.data.data.checkTasks;
         })
       },
	   //界面的侧边栏导航循环栏，将指定的数据写入进去
	   // 以达到动态效果及点击哪一个模块就可以进入哪一个模块进行查询
       haddle(val,index,GiveNum){
          var count = 0;
          var num = 0;
        for(let i of this.tableData){
          num++;
          if(i.type!=null){
            console.log(num)
            this.tableData[num-1].type=""

          }
        }
         for(let i of this.tableData){
           count++;
           if(i.id == val.id){
             this.$set(this.tableData[count-1],'type','primary')
           }
         }
         this.$refs.son.select(GiveNum,val);
       }

     }
   }
</script>

<style>
  .lineBlock{
    margin-left: 3%;
  }
  .heng{
    width: 15px;
    padding-top: 60px;
    border-bottom: 1px solid rgba(128, 128, 128, .35);
  }
  .shu{
    position: absolute;

    margin-left: 0.8%;
    height: calc(100% - 190px);
  /*  height: 50px; */
    border-left: 1px solid rgba(128, 128, 128, .35);
  }


  .AsideSatus{
    margin-top: 8%;
  }
  .AsideTitle{
    margin-top: 5%;
  }
  .FirstBlock{
    margin-left: 5%;
  }
  .AsideJINDUBlcok{
    font-size: 12px;
    margin-left: 5%;
    margin-top: 10%;
  }
  .AsideStatusBlcok{
    font-size: 12px;
    margin-left: 60%;
  }
  .AsideTitleBlcok{
    font-size: 16px;
    margin-left: 5%;
    margin-top: 10%;
  }
  .AsideBlcok{
     text-align: left;
     border: 1px solid #dfe2ea;
     width: 222px;
     min-height: 90px;
     border-radius: 8px;
  }
  .AsideSecondBlcok{
    margin-top: 4%;
    text-align: left;
    border: 1px solid #dfe2ea;
    width: 200px;
    min-height: 90px;
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Check/CheckMissionDeatil.vue